import React from 'react';
import styled from 'styled-components';

const TooltipContentContainer = styled.div`
  padding: 20px;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};

  .tooltipContentHeader {
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
  }

  .tooltipContentTitle {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    font-size: 12px;
    color: #abb5be;
    text-transform: uppercase;
  }

  .tooltipContentDate {
    margin-left: 120px;
    margin-right: 5px;
    font-size: 12px;
    color: #a9b6bf;
  }
`;

const TooltipContentValueContainer = styled.div`
  margin-top: 8px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  .tooltipContentValueLabel {
    font-size: 12px;
    color: #1c2b38;
  }

  .tooltipContentValues {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .tooltipContentValue {
    display: flex;
    flex-direction: row;
    :not(:last-child) {
      margin-right: 20px;
    }
    align-items: center;
    p {
      margin-left: 4px;
    }
  }
`;

const TooltipContent = ({
  title,
  data,
  currency,
  singleBar,
  labels,
  showName
}) => (
  <TooltipContentContainer>
    <div className="tooltipContentHeader">
      <h2 className="tooltipContentTitle">{title}</h2>
    </div>
    {data.map(
      (set, index) =>
        set && (
          <TooltipContentValueContainer>
            <p className="tooltipContentValueLabel">
              {!singleBar && labels[index]}{' '}
              {!showName === false && ` - ${set.name}`}
            </p>
            <div className="tooltipContentValues">
              {Object.keys(set).map(
                (key) =>
                  key !== 'name' &&
                  set[key].value && (
                    <div key={key} className="tooltipContentValue">
                      {currency ? (
                        <p>
                          {set[key].value &&
                            set[key].value.toLocaleString('fr-FR', {
                              style: 'currency',
                              currency: currency,
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1
                            })}
                        </p>
                      ) : (
                        <p>{set[key].value}</p>
                      )}
                    </div>
                  )
              )}
            </div>
          </TooltipContentValueContainer>
        )
    )}
  </TooltipContentContainer>
);

export default TooltipContent;
